import { Component, AfterViewInit, ChangeDetectorRef, HostListener   } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { AngularFirestore } from '@angular/fire/firestore';
import 'jarallax';
import { UserService } from './user.service';
declare var jarallax: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements AfterViewInit {

  statement = false;
  title = 'ValkyrieGameStudios';

  contactForm: FormGroup;
  validatingForm: FormGroup;

  disabledSubmitButton: boolean = true;
  optionsSelect: Array<any>;

  @HostListener('input') oninput() {

    if (this.contactForm.valid) {
      this.disabledSubmitButton = false;
      }
    }

  constructor(private fb: FormBuilder,private changeDetector: ChangeDetectorRef, public user: UserService) {
     

    this.contactForm = fb.group({
      'contactFormName': ['', Validators.required],
      'contactFormEmail': ['', Validators.compose([Validators.required, Validators.email])]
      });

  }


  ngAfterViewInit() {
    jarallax(document.querySelectorAll('.jarallax'), {
      speed: 0.2
    });
  }

  Submit(frm) {
    this.user.createSubscriber(frm.value.email, frm.value.name);
  }

  
  setVideo() {
    jarallax(document.querySelectorAll('.jarallax-my-video'), {
      speed: 0.2,
      videoSrc: 'https://www.youtube.com/channel/UCh42gl6gF4LFTI3KLVXoreg?view_as=subscriber'
    });
  }

  changeStatement() {
    this.statement = true;
    this.changeDetector.detectChanges();
    this.setVideo();
  }



}